// The rateSelector response already carries the rendered summary document,
// escaped inside the PriceTable CDATA of loan.optimalHistory.
const CDATA_OPEN = /^\s*<!\[CDATA\[/;
const CDATA_CLOSE = /\]\]>\s*$/;
const COMMENTS_CELL =
  /(Submitter's Comments<\/span>\s*<table[^>]*>\s*<tr>\s*<td class="mps_prntxt">)(<\/td>)/;

// Mirror BE's //LienData/PriceTable lookup. XML parsing decodes the
// entity-escaped CDATA wrapper and tolerates attributes on the tag.
const readPriceTable = (optimalHistory: string) => {
  const doc = new DOMParser().parseFromString(optimalHistory, 'text/xml');
  if (doc.getElementsByTagName('parsererror').length > 0) {
    return null;
  }
  const node =
    doc.querySelector('LienData > PriceTable') ??
    doc.querySelector('PriceTable');
  return node?.textContent || null;
};

const commentsToHtml = (value: string) =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\r?\n/g, '<br />');

export const buildLockSummaryDocument = (
  optimalHistory?: string,
  comments = '',
): string | null => {
  const priceTable = readPriceTable(optimalHistory || '');
  if (!priceTable) {
    return null;
  }
  const html = priceTable.replace(CDATA_OPEN, '').replace(CDATA_CLOSE, '');
  if (!comments) {
    return html;
  }
  // Replacer function, not a replacement string: comments carry dollar amounts,
  // and $&/$1/$' in a replacement string would splice the match back in.
  return html.replace(
    COMMENTS_CELL,
    (_match, open, close) => `${open}${commentsToHtml(comments)}${close}`,
  );
};
